import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import ar from 'vuetify/es5/locale/ar'
import en from 'vuetify/es5/locale/en'

// Vuetify's built-in strings (data-table footer: "rows per page", the page
// range text, ...) must follow the app locale; applyLocaleSettings() keeps
// `lang.current` in sync with vue-i18n after startup.
let storedLocale
try {
    storedLocale = localStorage.getItem('selectedLanguage')
} catch (e) {
    storedLocale = null
}

Vue.use(Vuetify, {
    theme: {
        primary: '#27a432',
        secondary: '#27a432',
        accent: '#2196F3',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    },
    customProperties: true,
    iconfont: 'fa4',
    lang: {
        locales: { ar, en },
        current: storedLocale === 'ar' ? 'ar' : 'en'
    }
});
